export const REF_INDENTIFIER = "___REF_FULLPATH_";

export interface ParsedRefDoc {
  ___refpath: string;
  ___refid: string;
}
